import React, { useContext } from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import CookieConsent from 'react-cookie-consent';
// import core components
import { UserContext } from 'contexts';
import { domHelper } from 'helpers';
import { StayInTouch } from '../StayInTouch';
import { queryHelper, nodeHelper } from 'helpers';
import siteInfo from '/config/site.js';
import PaymentsImg from '/static/images/footer/accepted-credit-cards.png';

import {
  Wrapper,
  Row,
  Columns,
  Links,
  ActionLink,
  Copyright,
  Section,
  TitleArrow,
  Nav,
} from './styles';

export const Footer = () => {
  const { user } = useContext(UserContext); // Context API to update user state
  const { navfooter } = useStaticQuery(graphql`
    query MyFooterQuery {
      navfooter: allMenuLinkContentMenuLinkContent(
        filter: {menu_name: {eq: "navfooter"}}
        sort: {weight: ASC}
      ) {
        edges {
          node {
            drupal_id
            menu_name
            title
            description
            weight
            drupal_parent_menu_item
            link {
              uri
            }
          }
        }
      }
  }
  `);
  const { setUpTree } = nodeHelper;
  const footerItems = setUpTree(navfooter);

  const toggleSection = e => {
    if (window.screen.width < 600) {
      const section = e.currentTarget.nextSibling;
      const arrow = e.currentTarget.querySelector('.nav-arrow');

      section.classList.toggle('visible');
      arrow.classList.toggle('active');
    }
  };

  return (
    <Wrapper>
      <Columns>
        <Nav>
          {footerItems.map((section, id) => (
            <Links key={queryHelper.getUniqueKey(section)}>
              <p onClick={e => toggleSection(e)}>
                <b>{section.description}</b>
                <TitleArrow className="nav-arrow">▼</TitleArrow>
              </p>
              <Section>
                {section.description === "Your Account" ? (
                !user ? <>
                  <ActionLink onClick={ev => domHelper.triggerClick("login-button")}><p>Sign In</p></ActionLink>
                  <ActionLink onClick={ev => domHelper.triggerClick("register-button")}><p>Register</p></ActionLink>
                </> : <>
                  <Link to="/my-account"><p>My Account</p></Link>
                  <ActionLink onClick={ev => domHelper.triggerClick("signout-button")}><p>Sign Out</p></ActionLink>
                </>
                ) :
                section.children.map(item => (
                  <Link
                    key={queryHelper.getUniqueKey(item)}
                    to={queryHelper.getLinkUrl(item.link)}
                  >
                    <p>{item.description}</p>
                  </Link>
                ))}
              </Section>
            </Links>
          ))}
        </Nav>
        <Row>
          <StayInTouch />
          <img src={PaymentsImg} alt="Accepted Credit Cards" />
        </Row>
      </Columns>
      <Copyright>{siteInfo.copyrightText(new Date().getFullYear())}</Copyright>
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        cookieName="gatsby-gdpr-google-analytics"
        //style={{ background: "#5095BF" }}
        buttonStyle={{
          border: '1px solid #EBEBEB',
          borderRadius: '10px',
          outline: 'none',
          boxSizing: 'border-box',
          background: '#FFF',
          color: '#5095BF',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: 'pointer',
        }}
      >
        <span style={{ fontSize: '16px' }}>This website uses cookies</span>
        <br />
        <span style={{ fontSize: '10px' }}>
          We use cookies to personalise content and ads, to provide social media
          features and to analyse our traffic. We also share information about
          your use of our site with our social media, advertising and analytics
          partners who may combine it with other information that you’ve
          provided -{' '}
          <a href="/privacy-policy">
            <span style={{ color: '#FFF', fontWeight: 'bold' }}>
              Privacy Policy
            </span>
          </a>
        </span>
      </CookieConsent>
    </Wrapper>
  );
};
